import { render, staticRenderFns } from "./EnrolmentEditorAgreementList.vue?vue&type=template&id=22242e34&scoped=true"
import script from "./EnrolmentEditorAgreementList.vue?vue&type=script&lang=js"
export * from "./EnrolmentEditorAgreementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22242e34",
  null
  
)

export default component.exports